import { LibraryArticleFavorite, LibraryArticleFavoriteAddRequest } from 'features/resources/types';
import { WellframeApi } from 'store/api';

const FAVORITES_BASE_PATH = '/api/v3/articles/favorites';

export const articleFavoritesService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getArticleFavorites: builder.query<LibraryArticleFavorite[], void>({
      query: () => FAVORITES_BASE_PATH,
    }),

    addArticleFavorite: builder.mutation<LibraryArticleFavorite, LibraryArticleFavoriteAddRequest>({
      query: ({ title, url, excerpt }) => ({
        url: FAVORITES_BASE_PATH,
        method: 'POST',
        body: { favorite: { title, url, excerpt } },
      }),
    }),

    removeArticleFavorite: builder.mutation<void, number>({
      query: (id) => ({
        url: `${FAVORITES_BASE_PATH}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetArticleFavoritesQuery,
  useLazyGetArticleFavoritesQuery,
  useAddArticleFavoriteMutation,
  useRemoveArticleFavoriteMutation,
} = articleFavoritesService;
